import _extends from "@babel/runtime-corejs2/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { useSelector, useDispatch } from 'react-redux';
import { Base, Layer, Notification } from '@gandi/ui';
import { closeNotification, clearNotificationTimeout, setNotificationTimeout } from '../../modules/actions';
import { selectNotifications } from '../../modules/selectors';
var styles = {
  "root": "NotificationsPlaceholder-root_2GL8J",
  "notification": "NotificationsPlaceholder-notification_dbQKm",
  "appear": "NotificationsPlaceholder-appear_2-vbc"
};
function NotificationsPlaceholder(_ref) {
  var className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var dispatch = useDispatch();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mounted = _React$useState2[0],
    setMounted = _React$useState2[1];
  var notifications = useSelector(selectNotifications);

  // The Layer will not render anything server side.
  // Prevent markup hydratation missmatch between server and client.
  React.useEffect(function () {
    setMounted(true);
  }, []);
  function renderNotification(notification) {
    var a11yProps = notification.intent === 'danger' ? {
      role: 'alert',
      'aria-live': 'assertive',
      'aria-atomic': true
    } : {
      role: 'status',
      'aria-live': 'polite',
      'aria-atomic': true
    };
    return /*#__PURE__*/React.createElement(Notification, _extends({
      key: notification.id,
      intent: notification.intent,
      title: notification.title,
      message: notification.message,
      dismissible: notification.dismissible,
      className: styles.notification,
      buttons: notification.buttons,
      onDismiss: function onDismiss() {
        dispatch(closeNotification(notification.id));
      },
      onMouseEnter: function onMouseEnter() {
        clearNotificationTimeout(notification);
      },
      onMouseLeave: function onMouseLeave() {
        setNotificationTimeout(notification, dispatch);
      }
    }, a11yProps));
  }
  return mounted ? /*#__PURE__*/React.createElement(Layer, {
    host: "messages",
    container: false
  }, /*#__PURE__*/React.createElement(Base, _extends({
    grid: true,
    "aria-live": "polite",
    className: clsx(styles.root, className)
  }, extraProps), notifications.map(renderNotification))) : null;
}
export default NotificationsPlaceholder;